<template>
  <page class="ab-screen">
    <unbounce-poster class="unbounce-poster" />
    <h2 style="font-style: italic;">
      Don't
      <span style="font-weight: bold;">give</span> your data to Big Tech firms,
      <span style="font-weight: bold;">rent</span> it out to advertisers and make them pay you for
      it.
    </h2>
    <div class="container">
      <d-rows />
      <sign-up-form class="sign-up" />
    </div>
  </page>
</template>

<script>
import Page from '@/components/common/Page.vue';
import UnbouncePoster from '@/components/unbounce/UnbouncePoster.vue';
import SignUpForm from '@/views/ab/SignUpForm.vue';
import DRows from '@/components/unbounce/DRows.vue';

export default {
  components: {
    Page,
    UnbouncePoster,
    SignUpForm,
    DRows,
  },
  data() {
    return {
      group1: {
        headline: this.$t('rewards.group-1.headline'),
        src: '/img/icons/check.svg',
        alt: this.$t('rewards.group-1.iconAlt'),
        items: [
          [
            this.$t('rewards.group-1.item-1.paragraph-1'),
            this.$t('rewards.group-1.item-1.paragraph-2'),
          ],
          [
            this.$t('rewards.group-1.item-2.paragraph-1'),
            this.$t('rewards.group-1.item-2.paragraph-2'),
          ],
          [this.$t('rewards.group-1.item-3.paragraph')],
          [this.$t('rewards.group-1.item-4.paragraph')],
        ],
      },
      group2: {
        headline: this.$t('rewards.group-2.headline'),
        src: '/img/icons/notcheck.svg',
        alt: this.$t('rewards.group-2.iconAlt'),
        items: [
          [this.$t('rewards.group-2.item-1.paragraph')],
          [this.$t('rewards.group-2.item-2.paragraph')],
        ],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors.scss';

.container {
  display: flex;
  width: 1000px;
  padding-bottom: 50px;
}
.unbounce-poster {
  height: 450px;
  background-position-y: -60px;
}
.footer {
  padding: 25px;
}
.poster {
  padding-top: 20px;
}
h2 {
  width: 950px;
  font-size: 28px;
  text-align: center;
  font-weight: 100;
  padding-top: 15px;
}
.sign-up {
  margin-top: 50px;
}
</style>
